import lowC from './Images/0_C.svg';
import lowCs from './Images/1_Cs.svg';
import lowD from './Images/2_D.svg';
import lowDs from './Images/3_Ds.svg';
import lowMidE from './Images/4-16_E.svg';
import lowMidEs from './Images/5-17_Es.svg';
import lowMidFs from './Images/6-18_Fs.svg';
import lowMidG from './Images/7-19_G.svg';
import lowMidGs from './Images/8-20_Gs.svg';
import lowMidA from './Images/9-21_A.svg';
import lowMidAs from './Images/10-22_As.svg';
import lowMidB from './Images/11-23_B.svg';
import lowMidBs from './Images/12-24_Bs.svg';
import midHiCs from './Images/13-25_Cs.svg';
import midD from './Images/14_D.svg';
import midDs from './Images/15_Ds.svg';
import hiD from './Images/26_D.svg';
import hiDs from './Images/27_Ds.svg';
import hiE from './Images/28_E.svg';
import hiEs from './Images/29_Es.svg';
import hiFs from './Images/30_Fs.svg';
import hiG from './Images/31_G.svg';
import hiGs from './Images/32_Gs.svg';
import hiA from './Images/33_A.svg';
import hiAs from './Images/34_As.svg';
import hiB from './Images/35_B.svg';
import hiC from './Images/36_C.svg';

const svgs = {
  lowC,
  lowCs,
  lowD,
  lowDs,
  lowMidE,
  lowMidEs,
  lowMidFs,
  lowMidG,
  lowMidGs,
  lowMidA,
  lowMidAs,
  lowMidB,
  lowMidBs,
  midHiCs,
  midD,
  midDs,
  hiD,
  hiDs,
  hiE,
  hiEs,
  hiFs,
  hiG,
  hiGs,
  hiA,
  hiAs,
  hiB,
  hiC
};

export default svgs;
